__webpack_require__.p = "/smartIntelligence-by-MJandTheMonstars/";